"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLTIP_POSITIONS = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
exports.TOOLTIP_POSITIONS = ['above', 'below'];
const Tooltip = _ref => {
  let {
    children,
    x,
    y,
    direction = 'below',
    contentTransform,
    style = {},
    width
  } = _ref;
  const tooltipRef = (0, react_1.useRef)();
  const [correction, setCorrection] = (0, react_1.useState)('translateX(-50%)');
  const hideShadow = (0, react_1.useRef)(false);
  const [hideFirstDraw, setHideFirstDraw] = (0, react_1.useState)(true);
  (0, react_1.useEffect)(() => {
    if (width) {
      const tooltipWidth = tooltipRef.current.clientWidth;
      const offset = Math.max(tooltipWidth / 2 - x, 0) || Math.min(0, width - x - tooltipWidth / 2);
      hideShadow.current = offset / tooltipWidth < -0.25;
      setCorrection(`translateX(${offset / tooltipWidth * 100 - 50}%)`);
    }
    setHideFirstDraw(false);
  }, [width, x]);
  return react_1.default.createElement("div", {
    ref: tooltipRef,
    className: `${styles_module_css_1.default['tooltip-wrapper']} ${styles_module_css_1.default[direction]}`,
    style: {
      top: direction === 'below' ? y : undefined,
      bottom: direction === 'above' ? `calc(100% - ${y}px)` : undefined,
      left: x,
      opacity: hideFirstDraw ? 0 : 1,
      ...style
    }
  }, !hideShadow.current && react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['tooltip-arrow']} ${styles_module_css_1.default['tooltip-shadow']}`
  }), react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-content'],
    style: {
      transform: contentTransform || correction
    }
  }, children), react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-arrow']
  }));
};
Tooltip.propTypes = {
  /**
   * Content for the tooltip.
   */
  children: prop_types_1.node,
  /**
   * X coordinate of the tooltip.
   */
  x: prop_types_1.number.isRequired,
  /**
   * Y coordinate of the tooltip.
   */
  y: prop_types_1.number.isRequired,
  /**
   * Specifies tooltip direction.
   */
  direction: (0, prop_types_1.oneOf)(exports.TOOLTIP_POSITIONS),
  /**
   * CSS transform string for tooltip content.
   * Setting this will override tooltip constraints
   * due to width.
   */
  contentTransform: prop_types_1.string,
  /**
   * Overrides style of tooltip wrapper.
   */
  style: react_style_proptype_1.default,
  /**
   * Width of parent. If set, tooltip body will be constained
   * within this width.
   * (Cannot use width constraint with a custom content transform)
   */
  width: prop_types_1.number
};
exports.default = Tooltip;